import toOpenToast from "@redux/toast/reducer";
import { combineReducers } from "redux";
import todoReducer from "../../redux/todo/reducer";
import toTranslateReducer from "@redux/Language/reducer";
import toAccountReducer from "@redux/Accounts/reducer";
import toUserReducer from "@redux/User/reducer";
import toPopupReducer from "@redux/Popup/reducer";
import toMediaReducer from "@redux/Media/reducer";
const rootReducer = combineReducers({
    todo: todoReducer,
    toTranslate: toTranslateReducer,
    toOpen: toOpenToast,
    toAccount: toAccountReducer,
    toUserManager : toUserReducer,
    toPopup: toPopupReducer,
    toMedia: toMediaReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
